const Report = () =>
  import(
    /* webpackChunkName: "financial-bank-account" */ '@/pages/financial/account/bank-account/index.vue'
    )
const Create = () =>
  import(
    /* webpackChunkName: "financial-bank-account" */ '@/pages/financial/account/bank-account/create.vue'
    )
const Edit = () =>
  import(
    /* webpackChunkName: "financial-bank-account" */ '@/pages/financial/account/bank-account/edit.vue'
    )

export default {
  path: 'bank-account',
  meta: {
    label: 'bankAccount',
    auth: 'bankAccount'
  },
  component: {
    name: 'BankAccount',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialBankAccount',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateBankAccount',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditBankAccount',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
